
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sc/[staticPageSlug]",
      function () {
        return require("private-next-pages/sc/[staticPageSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sc/[staticPageSlug]"])
      });
    }
  